export default __webpack_public_path__ + "static/media/home-hotel-resort-img-01.dd5ec763.jpg";